import { types } from '../types'

const initialState = {
    notificationList: []
}

const notificationReducer = (state = initialState, { type, notificationItem, notifications }) => {
    switch (type) {


        case types.CLOSE_NOTIFICATION: {

            return {
                ...state,
                notificationList: state.notificationList.filter((t) => t.type !== notificationItem.typ)
            }
        }

        case types.ADD_NOTIFICATION: {

            return {
                ...state,
                notificationList: notifications
            }
        }






        default:
            return state
    }
}

export default notificationReducer;